import axios from 'axios';

export interface Cep {
  erro?: boolean;
  cep: string;
  logradouro: string;
  complemento: string;
  unidade: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  regiao: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export class BrasilApiService {
  static async getCep(cep: string): Promise<Cep> {
    const cepOnlyNumbers = cep.replace(/\D/g, '');

    const response = await axios.get<Cep>(
      `https://viacep.com.br/ws/${cepOnlyNumbers}/json`,
    );

    return response.data;
  }
}
